const bubble15 = (color) => `
<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="322.186 747.085 60 60"><g data-name="Group 37"><path d="M322.186 777.085c0-16.569 13.431-30 30-30 16.568 0 30 13.431 30 30 0 16.568-13.432 30-30 30-16.569 0-30-13.432-30-30Z" fill="${color}" fill-rule="evenodd" data-name="Ellipse 4"/><g data-name="Group 10"><path d="M342.074 763.085a2.892 2.892 0 0 0-2.888 2.889v17.333a2.892 2.892 0 0 0 2.888 2.89h5.18l4.932 4.93 4.93-4.93h5.18a2.892 2.892 0 0 0 2.89-2.89v-17.333a2.892 2.892 0 0 0-2.89-2.889h-20.222Zm20.223 20.222h-6.376l-3.735 3.736-3.736-3.736h-6.376v-17.333h20.223v17.333Z" fill="#f5f5f5" fill-rule="evenodd" data-name="Vector"/><path d="M344.963 770.307h14.445v2.89h-14.445v-2.89Zm0 5.778h10.111v2.889h-10.11v-2.889Z" fill="#f5f5f5" fill-rule="evenodd" data-name="Vector"/></g></g></svg>
`;
export default bubble15;



//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/bubble15.js
// module id = null
// module chunks = 